// LOOTUS — resolução única de rótulo/estado do provedor bancário da
// PLATAFORMA (Finalização do Faturamento Master, Parte F). Antes,
// GestaoComercial.jsx e Financeiro.jsx só reconheciam
// boleto_modo === "mercado_pago" para mostrar badge/"Abrir boleto"/"Ver
// PIX"/"Sincronizar" — uma cobrança emitida via Asaas (boleto_modo ===
// "asaas") ficava sem nenhuma ação visível. Compartilhado entre as duas
// telas para nunca haver duas fontes de verdade sobre "isto é um
// instrumento real".
export const PLATFORM_PROVIDER_LABEL = {
  mercado_pago: "Mercado Pago",
  asaas: "Asaas",
};

export const REAL_PLATFORM_PROVIDER_MODES = ["mercado_pago", "asaas"];

export function isRealInstrumentMode(modo) {
  return REAL_PLATFORM_PROVIDER_MODES.includes(modo);
}

export function platformProviderLabel(modo) {
  return PLATFORM_PROVIDER_LABEL[modo] || null;
}
